import { Component, Input, ChangeDetectionStrategy } from '@angular/core';

@Component({
  selector: 'template-card',
  templateUrl: './template-card.component.html',
  styleUrls: ['./template-card.component.scss'],
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false
})
export class TemplateCardComponent {
  @Input() public name: string = '';
  @Input() public title: string = '';
  @Input() public imageUrl: string = '';
  @Input() public description: string = '';
}
